import { createContext } from "react";
import { LivePageStore } from "@state/stores/offer/live/LivePageStore";
import { Sport } from "@gp/models";
import { MainOfferStore, SportOffer } from "@gp/offer";
import { LiveHighlightsViewStore } from "@state/stores/offer/home/LiveHighlightsViewStore";
import { LastMinuteViewStore } from "@state/stores/offer/home/LastMinuteViewStore";
import { ToggleStore } from "@state/stores/offer/shared/ToggleStore";
import { HighlightsViewStore } from "@state/stores/offer/home/HighlightsViewStore";
import { MostPlayedViewStore } from "@state/stores/offer/home/MostPlayedViewStore";
import SearchViewStore from "../../stores/offer/search/SearchViewStore.mobile";
import PrematchOfferStore from "@state/stores/offer/prematch/PrematchOfferStore";
import { FavoriteOfferStore } from "@state/stores/offer/shared/FavoriteOfferStore";
import TopTournamentsOfferStore from "@state/stores/offer/home/TopTournamentsOfferStore";
import EventViewStore from "@state/stores/offer/event/EventViewStore.mobile";
import OfferSpotlightStore from "@state/stores/cms/OfferSpotlightStore";
import { cdn } from "@data-types/offer/prematch/PrematchHeaderTypes";

export type StoreMapping = {
	LivePageStore: LivePageStore;
	BaseOfferStore: TBaseOfferContext;
	LiveHighlightsViewStore: LiveHighlightsViewStore;
	LastMinuteViewStore: LastMinuteViewStore;
	HighlightsViewStore: HighlightsViewStore;
	MostPlayedViewStore: MostPlayedViewStore;
	SearchViewStore: SearchViewStore;
	PrematchOfferStore: PrematchOfferStore;
	FavoriteOfferStore: FavoriteOfferStore;
	TopTournamentsOfferStore: TopTournamentsOfferStore;
	EventViewStore: EventViewStore;
	OfferSpotlightStore: OfferSpotlightStore;
	// Add more mappings here as needed
};

export enum OfferStore {
	LivePageStore = "LivePageStore",
	BaseOfferStore = "BaseOfferStore",
	LiveHighlightsViewStore = "LiveHighlightsViewStore",
	LastMinuteViewStore = "LastMinuteViewStore",
	HighlightsViewStore = "HighlightsViewStore",
	MostPlayedViewStore = "MostPlayedViewStore",
	SearchViewStore = "SearchViewStore",
	PrematchOfferStore = "PrematchOfferStore",
	FavoriteOfferStore = "FavoriteOfferStore",
	TopTournamentsOfferStore = "TopTournamentsOfferStore",
	EventViewStore = "EventViewStore",
	OfferSpotlightStore = "OfferSpotlightStore",
}
export type TOfferContext<T extends keyof StoreMapping = "BaseOfferStore"> =
	StoreMapping[T];
export const OfferContext = createContext<TOfferContext | null>(null);

type TBaseOfferContext = {
	isLoading?: boolean;
	isLoadingProcess?: boolean;
	isEmpty: boolean;

	/* onInitialize: VoidFunction; */
	sportsList: Sport[];

	filteredEventsByActiveSport: SportOffer[];
	eventIdsForEventSwitcher: string[];
	collapsedTournamentsStore: ToggleStore;
	expandAllTournaments: (args?: string[]) => void;
	collapseAllTournaments: (args?: string[]) => void;
	isGroupedByTournament?: boolean;
	getHeaderInfo?: {
		name: string;
		cdnData: cdn;
	} | null;
	shouldHideTournamentNameAndCategory?: boolean;
} & MainOfferStore;
